import { LSP } from '@LSP/base/types';
import { WebSocketBase } from '@LSP/websocket/WebSocketBase';
import { BackEndCodeLanguageType } from '@prophecy/graphql-types/enums';

import { ValidateEntityRequestType } from '../config';

enum Methods {
  startOrConnectTranspiler = 'startOrConnectBulkTranspiler',
  stopBulkTranspilerSession = 'stopBulkTranspilerSession',

  startValidation = 'startValidation',
  stopValidation = 'stopValidation',
  setEntities = 'setEntities',
  getAssociatedEntities = 'getAssociatedEntities',
  initialState = 'initialState',
  resetState = 'resetState',
  startAnalysis = 'startAnalysis',
  analysisProcessUpdate = 'analysisProcessUpdate',
  stopAnalysisSession = 'stopAnalysisSession'
}

export enum Notifications {
  //Transpiler Notification

  bulkTranspileEstimation = 'bulkTranspileEstimation',
  bulkTranspilerProcessUpdate = 'bulkTranspilerProcessUpdate',
  bulkTranspilerProcessInitialUpdate = 'bulkTranspilerProcessInitialUpdate',
  bulkTranspilerProcessSuccess = 'bulkTranspilerProcessSuccess',
  bulkTranspilerProcessError = 'bulkTranspilerProcessError',
  stopBulkTranspilerSessionSuccess = 'stopBulkTranspilerSessionSuccess',
  validationUpdate = 'validationUpdate',
  validationSuccess = 'validationSuccess',
  stopBulkTranspilerValidationSessionSuccess = 'stopBulkTranspilerValidationSessionSuccess',
  setEntitiesSuccess = 'setEntitiesSuccess',
  setEntitiesError = 'setEntitiesError',
  validationError = 'validationError',
  uploadProcessingUpdate = 'uploadProcessingUpdate',
  uploadProcessingSuccess = 'uploadProcessingSuccess',
  uploadProcessingFailed = 'uploadProcessingFailed',
  error = 'error',
  getAssociatedEntitiesSuccess = 'getAssociatedEntitiesSuccess',
  getAssociatedEntitiesError = 'getAssociatedEntitiesError',
  resetSuccess = 'resetStateSuccess',
  analysisProcessUpdate = 'analysisProcessUpdate',
  analysisSuccess = 'analysisSuccess',
  analysisFailure = 'analysisFailure',
  downloadAnalysisReport = 'downloadAnalysisReport'
}

export class TranspilerClient extends WebSocketBase<Notifications | LSP.Notification, Methods | LSP.Method> {
  startOrConnectTranspiler(params: {
    language: string;
    enableSubgraph: boolean;
    bulkTranspilerId: string;
    generateConfigsOnly?: boolean;
  }) {
    this.request({ method: Methods.startOrConnectTranspiler, params });
  }

  resetState(params: { bulkTranspilerId: string; newTranspilerType: string }) {
    this.request({ method: Methods.resetState, params });
  }

  getInitialState(params: { bulkTranspilerId: string }) {
    this.request({ method: Methods.initialState, params });
  }

  stopTranspilation(params: { bulkTranspilerId: string }) {
    this.request({ method: Methods.stopBulkTranspilerSession, params });
  }

  stopValidation(params: { bulkTranspilerId: string }) {
    this.request({ method: Methods.stopValidation, params });
  }

  startValidation(params: {
    bulkTranspilerId: string;
    language: BackEndCodeLanguageType;
    entitiesRequest: ValidateEntityRequestType;
  }) {
    this.request({ method: Methods.startValidation, params });
  }

  setEntities(params: { bulkTranspilerId: string; entitiesRequest: ValidateEntityRequestType }) {
    return this.request({ method: Methods.setEntities, params });
  }

  getAssociatedEntities(params: { bulkTranspilerId: string; entitiesRequest: ValidateEntityRequestType }) {
    this.request({ method: Methods.getAssociatedEntities, params });
  }

  startAnalysis(params: {
    bulkTranspilerId: string;
    language: string;
    enableSubgraph: boolean;
    generateConfigsOnly?: boolean;
  }) {
    this.request({ method: Methods.startAnalysis, params });
  }

  stopAnalysisSession(params: { bulkTranspilerId: string }) {
    this.request({ method: Methods.stopAnalysisSession, params });
  }
}
